"use strict";

var _objectSpread = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ActionItemToggleButton = void 0;
var _cn = require("@udecode/cn");
var _toolbar = require("./toolbar");
var _react = _interopRequireDefault(require("react"));
var _useActionItem = require("../hooks/useActionItem");
var _Icon = require("../../forecast-v2/components/media/icon/Icon");
var _jsxRuntime = require("react/jsx-runtime");
/* this button does not exist in v36 so it was built from scratch */

var ActionItemToggleButton = exports.ActionItemToggleButton = (0, _cn.withRef)(function (rest, ref) {
  var state = (0, _useActionItem.useActionItemState)();
  var _ref = (0, _useActionItem.useActionItem)(state),
    props = _ref.props;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_toolbar.ToolbarButton, _objectSpread({
    ref: ref,
    tooltip: "Todo"
  }, props, rest, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
      icon: 'checkboxes'
    })
  }));
});